/**
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const LoadingQueryKeys = {
  all: ['user'] as const,
  lists: () => [...LoadingQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...LoadingQueryKeys.lists(), { filters }] as const,
  details: () => [...LoadingQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...LoadingQueryKeys.details(), id] as const,
};
